import { render, staticRenderFns } from "./_aside-menu.vue?vue&type=template&id=d334af28&"
import script from "./_aside-menu.vue?vue&type=script&lang=js&"
export * from "./_aside-menu.vue?vue&type=script&lang=js&"
import style0 from "./_aside-menu.vue?vue&type=style&index=0&id=d334af28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports